import { render, staticRenderFns } from "./TabelaMateriaisTransferencia.vue?vue&type=template&id=2426d711&scoped=true&"
import script from "./TabelaMateriaisTransferencia.vue?vue&type=script&lang=js&"
export * from "./TabelaMateriaisTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMateriaisTransferencia.vue?vue&type=style&index=0&id=2426d711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2426d711",
  null
  
)

export default component.exports